import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: [],
  states: []
}

const renderList = (topic) => {
  return topic.map((item, index) => (
    <li
      key={index}
      className={
        'mdn-HelpPassword-list-item ' +
        (item.isDone ? 'mdn-HelpPassword-list-item-done' : null)
      }
    >
      <span
        className={`mdn-HelpPassword-icon mdn-Icon-${
          item.isDone ? 'verificado' : 'fechar'
        } mdn-Icon--sm"`}
      />
      <p className="mdn-Text mdn-Text--caption">{item.requirement}</p>
    </li>
  ))
}

export default function HelpPassword(props) {
  const { data, children, ...rest } = props
  const dataHelpPassword = data || this.props.dataHelpPassword || {}

  return (
    <div {...rest} className={resolveProps(props, config, 'HelpPassword')}>
      <h3 className="mdn-HelpPassword-title">{props.children}</h3>
      <ul className="mdn-HelpPassword-list">{renderList(dataHelpPassword)}</ul>
    </div>
  )
}

HelpPassword.propTypes = {
  dataHelpPassword: PropTypes.array,
  children: PropTypes.node,
  data: PropTypes.shape({
    isDone: PropTypes.bool,
    requirement: PropTypes.string
  })
}
